const RESOURCE_NAME = '/shipments-locator';

export default axios => ({
    getToken(data, params){
        return axios.post(`${RESOURCE_NAME}/token`, data, {params});
    },
    getAppUser(data, params){
        return axios.post(`${RESOURCE_NAME}/app-user`, data, {params});
    },
    getShipments(data, params){
        return axios.post(`${RESOURCE_NAME}/shipments`, data, {params});
    },
    getShipmentsPackage(data, params){
        return axios.post(`${RESOURCE_NAME}/shipments-package`, data, {params});
    },
    getUnits(data, params){
        return axios.post(`${RESOURCE_NAME}/units`, data, {params});
    },
    getUnitsLmsgs(data, params){
        return axios.post(`${RESOURCE_NAME}/units-lmsgs`, data, {params});
    },
    getUnitWeather(unitId, data, params){
        return axios.post(`${RESOURCE_NAME}/unit/${unitId}/weather`, data, {params});
    },
    getUnitEta(unitId, data, params){
        return axios.post(`${RESOURCE_NAME}/unit/${unitId}/eta`, data, {params});
    },
    checkToken(data, params){
        return axios.post(`${RESOURCE_NAME}/check`, data, {params});
    },

});